import React from 'react';
import { Link } from 'react-router-dom';
import { NAV_LINKS } from '../data/siteMap';

const socialLinks = [
  { href: 'https://x.com/puremedify', label: 'X', icon: (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.39 3H17.6L12 10.29 6.4 3H3.61l7.47 9.9L3 21h2.79L12 13.71 18.21 21H21l-8.47-11.1L20.39 3Z"/>
  </svg>
  ) },
  { href: 'https://www.facebook.com/profile.php?id=61578816879081', label: 'Facebook', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0" /></svg>
  ) },
  { href: 'https://www.instagram.com/puremedify/', label: 'Instagram', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.242 1.308 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.242 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.242-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608.974-.974 2.242-1.246 3.608-1.308C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.775.13 4.602.402 3.635 1.37 2.668 2.337 2.396 3.51 2.338 4.788.013 8.332 0 8.741 0 12c0 3.259.013 3.668.072 4.948.058 1.277.33 2.45 1.297 3.417.967.967 2.14 1.239 3.417 1.297C8.332 23.987 8.741 24 12 24c3.259 0 3.668-.013 4.948-.072 1.277-.058 2.45-.33 3.417-1.297.967-.967 1.239-2.14 1.297-3.417.059-1.28.072-1.689.072-4.948 0-3.259-.013-3.668-.072-4.948-.058-1.277-.33-2.45-1.297-3.417-.967-.967-2.14-1.239-3.417-1.297C15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm7.2-11.162a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" /></svg>
  ) },
];

const Footer = () => (
  <footer className="bg-white border-t border-gray-200 mt-8">
    <div className="max-w-7xl mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
      <Link to="/" className="flex items-center gap-2 mb-4 md:mb-0">
        <img src={process.env.PUBLIC_URL + '/image/puremedify.png'} alt="Purmedify Logo" className="w-36 h-auto object-contain rounded-lg" />
      </Link>
      <nav className="flex flex-wrap gap-4 justify-center text-sm">
        {NAV_LINKS.map((link) => (
          <Link key={link.path} to={link.path} className="text-gray-600 hover:text-brand transition">
            {link.label}
          </Link>
        ))}
      </nav>
      <div className="flex gap-4">
        {socialLinks.map((s) => (
          <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand transition" aria-label={s.label}>
            {s.icon}
          </a>
        ))}
      </div>
    </div>
    <div className="text-center text-gray-400 text-xs pb-4">&copy; {new Date().getFullYear()} PUREMEDIFY LIMITED. All rights reserved.</div>
  </footer>
);

export default Footer; 